import generalSettings from "./menus/general.settings";
import banquetMenu from "./menus/banquet.menu";
import mealRegistrationMenu from "./menus/meal_registration.menu";
import { FeatureFlagService, FeatureList } from "sentec-core-ts";

export default {
  menu: [
    {
      icon: "mdi-view-dashboard-outline",
      key: "menu.dashboard",
      text: "Dashboard",
      link: "/dashboard"
    },
    {
      icon: "mdi-cart-outline",
      key: "menu.quick-order",
      text: "Quick Order",
      link: "/quick-order"
    },
    {
      icon: "mdi-table-furniture",
      key: "menu.tables",
      text: "Tables",
      link: "/tables"
    },
    {
      icon: "mdi-cart",
      text: "Order Histories",
      key: "menu.order.histories",
      level: 1,
      expanded: true,
      link: "/orders",
      keywords: "OrderHistory",
      items: [
        { level: 3, icon: "fas fa-border-all", text: "All", link: "/orders/all", keywords: "all" },
        { level: 3, icon: "fas fa-border-all", text: "Closed", link: "/orders/paid", keywords: "paid" },
        { level: 3, icon: "fas fa-border-all", text: "Open", link: "/orders/unpaid", keywords: "unpaid" },
        { level: 3, icon: "fas fa-border-all", text: "Deleted Sent Orders", link: "/orders/deleted-sent-orders", keywords: "deleted-sent-orders" },
        { level: 3, icon: "fas fa-border-all", text: "Deleted Order Payments", link: "/orders/deleted-order-payments", keywords: "deleted-order-payments" },
        { level: 3, icon: "fas fa-border-all", text: "Transfer Order History", link: "/orders/transfer-order-history", keywords: "transfer-order-history" }
      ]
    },
    {
      icon: "mdi-cart",
      text: "FB Menu Order Request",
      key: "menu.fb-menu-order-request",
      level: 1,
      expanded: true,
      link: "/fb-menu-order-request",
      keywords: "FBMenuOrderRequest",
      items: [
        { level: 3, icon: "fas fa-border-all", text: "All", link: "/fb-menu-order-request/all", keywords: "all" },
        { level: 3, icon: "fas fa-border-all", text: "Closed", link: "/fb-menu-order-request/paid", keywords: "closed" },
        { level: 3, icon: "fas fa-border-all", text: "Open", link: "/fb-menu-order-request/unpaid", keywords: "open" },
      ],
      featureFlagCode: FeatureList.FbMenuOrder
    },
    {
      icon: "fas fa-clock", text: "Closed Days", link: "/working-day", key: "menu.closed.days", keywords: "working day closed days history"
    },
    mealRegistrationMenu,
    {
      icon: "fas fa-border-all", text: "Table Reservation", link: "/table-reservation", key: "menu.table.reservation", keywords: "table-reservation" },
    {
      icon: "mdi-wrench-outline",
      key: "menu.maintenance-request",
      text: "Maintenance Request",
      link: "/housekeeping/maintenance-request",
      keywords: "Maintenance Request",
      external: true,
    },
    {
      icon: "mdi-briefcase-arrow-up-down-outline",
      key: "menu.item-loan",
      text: "Item Loan",
      link: "/housekeeping/loan",
      keywords: "Item Loan",
      external: true,
    },
    {
      icon: "mdi-monitor",
      key: "Screens",
      text: "Screens",
      link: "/screens"
    },
    {
      icon: "mdi-receipt-text-outline",
      key: "Captain Order",
      text: "Captain Order",
      link: "/captain-order"
    },
    generalSettings,
    banquetMenu,
    {
      icon: "mdi-google-spreadsheet",
      key: "menu.reports",
      text: "Reports",
      link: "/reports",
      keywords: "cashier sales report"
    },
    {
      icon: "mdi-receipt-text-clock-outline",
      key: "menu.master-account",
      text: "Master Account",
      link: "/master-account",
      keywords: "Master Account",
      external: true,
    },
    {
      icon: "mdi-google-spreadsheet",
      key: "menu.reports",
      text: "Income Audit",
      link: "/income-audit",
      keywords: "income audit"
    },
    {
      icon: "mdi-monitor",
      key: "Tax Interface Integration Log",
      text: "Tax Interface Integration Log",
      link: "/tax-interface-integration-log",
      keywords: "tax interface integration log"
    },
    {
      icon: "mdi-monitor",
      key: "Outlet Status",
      text: "Outlet Status",
      link: "/outlet-status",
      keywords: "outlet status"
    },
    {
      icon: "mdi-table",
      key: "Table Label Management",
      text: "Table Label Management",
      link: "/table-label-management",
      keywords: "table label management"
    },
    {
      icon: "mdi-account-tie",
      key: "menu.waiter",
      text: "Waiter",
      link: "/master-data/waiter",
      keywords: "waiter"
    },
    { icon: "mdi-nfc-tap",
      key: "menu.nfc",
      text: "Manage NFC Bracelet",
      "is-dialog-menu": true,
      component: "st-bracelet-nfc-dialog",
      link: "",
      keywords: "manage nfc bracelet",
      "permission-enum": "ACTION_ALLOW_MANAGE_NFC_BRACELET"
    },
  ],

  // footer links
  footer: [{
    text: "Docs",
    key: "menu.docs",
    href: "https://docs.pms.sentec.io",
    target: "_blank"
  }]
};
